import {
  GET_ENTERPRISE_PROFILE,
  GET_ENTERPRISE_PROFILE_SUCCESS,
  GET_ENTERPRISE_PROFILE_FAILURE,
} from './action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getEnterpriseProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ENTERPRISE_PROFILE:
      return { ...state, loading: true };
    case GET_ENTERPRISE_PROFILE_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_ENTERPRISE_PROFILE_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getEnterpriseProfileReducer;
